export default __webpack_public_path__ + "static/Privacy-Notice_EGIB_EN-a30aecac4d2ae85d0329b88bada23d8b.pdf";